/**
 * Auth Layout
 * Shared dark background with glassmorphism card for all auth pages
 */

import React from 'react';
import { Hand } from 'lucide-react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="dark auth-page min-h-screen flex items-center justify-center bg-[#0f1117] py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Decorative gradient blobs */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full bg-primary-500/10 blur-[120px]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -left-40 w-[400px] h-[400px] rounded-full bg-accent-500/5 blur-[120px]"
      />

      {/* Card */}
      <div className="auth-card relative z-10 max-w-md w-full space-y-8 p-10 backdrop-blur-xl bg-white/[0.07] border border-white/[0.1] shadow-xl rounded-2xl">
        {children}
      </div>
    </div>
  );
};

/** Reusable brand header with Hand icon + gradient text */
export const AuthBrand: React.FC<{ subtitle?: string }> = ({ subtitle }) => (
  <div className="text-center">
    <Hand className="mx-auto h-10 w-10 text-primary-400 mb-3" strokeWidth={1.8} />
    <h1 className="text-3xl font-bold bg-gradient-to-r from-primary-400 to-primary-600 bg-clip-text text-transparent">
      HighFive
    </h1>
    {subtitle && (
      <p className="mt-2 text-base font-medium text-gray-400">{subtitle}</p>
    )}
  </div>
);

export default AuthLayout;
